import { render, staticRenderFns } from "./PullData.vue?vue&type=template&id=60fa36f0"
import script from "./PullData.vue?vue&type=script&lang=js"
export * from "./PullData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports